module.exports = __webpack_public_path__ + "img/cover-minigame-bg.8ba895e0.jpg";